import React from "react";

function ProgressCircle({
  progress = 0,
  strokeWidth = 4,
  ballStrokeWidth = 15,
  reduction = 0.25,
  transitionDuration = 1.5,
  transitionTimingFunction = "ease",
  background = "#264a7380",
  hideBall = false,
  hideValue = false,
  gradient = [
    {
      stop: 0.0,
      color: "#17b780",
    },
    {
      stop: 1,
      color: "#1e7256",
    },
  ],
  subtitle = "",
  style,
  className,
  isVisible
}) {
  progress = Math.round(progress * 100) / 100;
  const [progressBar, setProgressBar] = React.useState(0);

  React.useEffect(() => {
    if (isVisible) {

      if (progress > progressBar) {
        setTimeout(() => {
          setProgressBar(progressBar + 1);
        }, 25);
      }
    }

  }, [progress, progressBar, isVisible]);

  const width = 150;
  const center = width / 2;
  const height = 200 || center + center * Math.cos(reduction * Math.PI);
  const [unique] = React.useState(() => Math.random().toString());
  const rotate = 90 + 180 * reduction;
  const r = center - strokeWidth / 2 - ballStrokeWidth / 2;
  const circumference = Math.PI * r * 2;
  const offset = (circumference * (100 - progressBar * (1 - reduction))) / 100;
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "circle-progress",
      style: style,
    },
    /*#__PURE__*/ React.createElement(
      "svg",
      { width: width, height: height },
      /*#__PURE__*/ React.createElement(
        "defs",
        null,
        /*#__PURE__*/ React.createElement(
          "linearGradient",
          {
            id: "gradient" + unique,
            x1: "0%",
            y1: "0%",
            x2: "0%",
            y2: "100%",
          },
          gradient.map(({ stop, color }) =>
            /*#__PURE__*/ React.createElement("stop", {
            key: stop,
            offset: stop * 100 + "%",
            stopColor: color,
          })
          )
        )
      ),
      !hideValue &&
        /*#__PURE__*/ React.createElement(
        "text",
        {
          className: "circle-progress-text",
          x: center,
          y: center,
          textAnchor: "middle",
          fontSize: "30",
        },
        progressBar,
        "%"
      ),

      /*#__PURE__*/ React.createElement("circle", {
        transform: `rotate(${rotate} ${center} ${center})`,
        id: "path",
        cx: center,
        cy: center,
        r: r,
        strokeWidth: strokeWidth,
        strokeDasharray: circumference,
        strokeDashoffset: circumference * reduction,
        fill: "none",
        stroke: background,
        strokeLinecap: "round",
      }),
      /*#__PURE__*/ React.createElement("circle", {
        style: {
          transition: `stroke-dashoffset ${transitionDuration}s ${transitionTimingFunction}`,
        },
        transform: `rotate(${rotate} ${center} ${center})`,
        id: "path",
        cx: center,
        cy: center,
        r: r,
        strokeWidth: strokeWidth,
        strokeDasharray: `${circumference}`,
        strokeDashoffset: offset,
        fill: "none",
        stroke: `url(#gradient${unique})`,
        strokeLinecap: "round",
      }),
      !hideBall &&
        /*#__PURE__*/ React.createElement("circle", {
        style: {
          transition: `stroke-dashoffset ${transitionDuration}s ${transitionTimingFunction}`,
        },
        transform: `rotate(${rotate} ${center} ${center})`,
        id: "path",
        cx: center,
        cy: center,
        r: r,
        strokeWidth: ballStrokeWidth,
        strokeDasharray: `1 ${circumference}`,
        strokeDashoffset: offset,
        fill: "none",
        stroke: `url(#gradient${unique})`,
        strokeLinecap: "round",
      })
    )
  );
}

export default ProgressCircle;
